import ActiveSchedule from './components/ActiveSchedule';
import { ScheduledLinesPropType } from './types';

function Page({ scheduledLines }) {
  return ActiveSchedule({ scheduledLines });
}

Page.propTypes = {
  scheduledLines: ScheduledLinesPropType,
};

export default Page;
